export default __webpack_public_path__ + "static/media/Spring21_12.b2935009.png";